import React from 'react';
import { transactionTypes } from '../../../domain/familyAccount';
import s from './transaction.module.css';

// The five ledger primitives, each introduced by what it is *for* rather than
// by its effect on the balance. MMS's framing is worth keeping — "use when a
// family pays you money" tells a teacher which one they want; "decreases amount
// owing" makes them work it out.
//
// The table is `core/src/account.rs`'s, so a phone's picker offers the same
// five sentences; asked at render, because `loadCore()` is awaited after
// collection (#226).

export default function TransactionTypePicker({ onPick }) {
  return (
    <div className={s.body}>
      {transactionTypes().map((t) => (
        <button key={t.id} className={s.typeCard} onClick={() => onPick(t.id)}>
          <div className={s.typeTitle}>{t.title}</div>
          <div className={s.typeDesc}>{t.desc}</div>
        </button>
      ))}
    </div>
  );
}
